import gsap from 'gsap';
import MorphSVGPlugin from 'gsap/MorphSVGPlugin';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { IconMoneyReturn } from '../Misc/MoneyReturn';
gsap.registerPlugin(MorphSVGPlugin);
const Wrapper = styled.div `
  --money-repeat-rotate: 360deg;

  position: relative;
`;
const Money = styled(IconMoneyReturn) `
  path {
    &:nth-child(2) {
      transform: rotate(var(--money-repeat-rotate));
      transform-origin: 72.5% 72.5%;
    }
  }
`;
export const IconMoney = (props) => {
    const wrapperRef = createRef();
    useEffect(() => {
        const wrapper = wrapperRef.current;
        const path = wrapper?.querySelector('path:nth-child(3)');
        const dots = wrapper?.querySelector('path:nth-child(1)');
        if (!wrapper || !path || !dots) {
            return;
        }
        gsap.to(wrapper, {
            '--money-repeat-rotate': '0deg',
            duration: 1,
            repeat: -1,
            repeatDelay: 1,
        });
        gsap.to(dots, {
            keyframes: new Array(2)
                .fill([
                {
                    ease: 'none',
                    morphSVG: 'M13.4167 6C13.4167 5.58579 13.7525 5.25 14.1667 5.25H15C15.4142 5.25 15.75 5.58579 15.75 6C15.75 6.41421 15.4142 6.75 15 6.75H14.1667C13.7525 6.75 13.4167 6.41421 13.4167 6ZM10.4519 7.17312C10.221 6.96108 9.91762 6.84501 9.60367 6.84915C9.2831 6.85339 8.97686 6.98261 8.75016 7.2093C8.52347 7.436 8.39424 7.74224 8.39001 8.06281C8.38587 8.37676 8.50193 8.68015 8.71398 8.91104C8.94487 9.12309 9.24826 9.23915 9.56221 9.23501C9.88278 9.23077 10.189 9.10155 10.4157 8.87486C10.6424 8.64816 10.7716 8.34192 10.7759 8.02135C10.78 7.7074 10.6639 7.40401 10.4519 7.17312ZM9.58386 5.34928C10.2954 5.33989 10.9824 5.60866 11.4987 6.09835C11.5082 6.10744 11.5176 6.11677 11.5267 6.12635C12.0164 6.64261 12.2851 7.32966 12.2757 8.04116C12.2663 8.75266 11.9795 9.43237 11.4764 9.93552C10.9732 10.4387 10.2935 10.7255 9.58202 10.7349C8.87052 10.7443 8.18347 10.4755 7.66721 9.98581C7.65763 9.97672 7.64829 9.96739 7.63921 9.95781C7.14952 9.44155 6.88075 8.7545 6.89014 8.043C6.89954 7.33151 7.18635 6.65179 7.6895 6.14864C8.19265 5.6455 8.87236 5.35868 9.58386 5.34928ZM3.41669 9.83333C3.41669 9.41912 3.75247 9.08333 4.16669 9.08333H5.00002C5.41423 9.08333 5.75002 9.41912 5.75002 9.83333C5.75002 10.2475 5.41423 10.5833 5.00002 10.5833H4.16669C3.75247 10.5833 3.41669 10.2475 3.41669 9.83333Z',
                },
                {
                    ease: 'none',
                    morphSVG: 'M13.4167 5C13.4167 4.58579 13.7524 4.25 14.1667 4.25H15C15.4142 4.25 15.75 4.58579 15.75 5C15.75 5.41421 15.4142 5.75 15 5.75H14.1667C13.7524 5.75 13.4167 5.41421 13.4167 5ZM10.4519 7.17312C10.221 6.96108 9.91759 6.84501 9.60364 6.84915C9.28307 6.85339 8.97683 6.98261 8.75013 7.2093C8.52344 7.436 8.39421 7.74224 8.38998 8.06281C8.38583 8.37676 8.5019 8.68015 8.71395 8.91104C8.94484 9.12309 9.24823 9.23915 9.56218 9.23501C9.88275 9.23077 10.189 9.10155 10.4157 8.87486C10.6424 8.64816 10.7716 8.34192 10.7758 8.02135C10.78 7.7074 10.6639 7.40401 10.4519 7.17312ZM9.58383 5.34928C10.2953 5.33989 10.9824 5.60866 11.4986 6.09835C11.5082 6.10744 11.5176 6.11677 11.5266 6.12635C12.0163 6.64261 12.2851 7.32966 12.2757 8.04116C12.2663 8.75266 11.9795 9.43237 11.4763 9.93552C10.9732 10.4387 10.2935 10.7255 9.58199 10.7349C8.87049 10.7443 8.18344 10.4755 7.66718 9.98581C7.6576 9.97672 7.64826 9.96739 7.63918 9.95781C7.14949 9.44155 6.88072 8.7545 6.89011 8.043C6.89951 7.33151 7.18632 6.65179 7.68947 6.14864C8.19262 5.6455 8.87233 5.35868 9.58383 5.34928ZM3.41666 10.8333C3.41666 10.4191 3.75244 10.0833 4.16666 10.0833H4.99999C5.4142 10.0833 5.74999 10.4191 5.74999 10.8333C5.74999 11.2475 5.4142 11.5833 4.99999 11.5833H4.16666C3.75244 11.5833 3.41666 11.2475 3.41666 10.8333Z',
                },
            ])
                .flat(),
            duration: 1,
            repeat: -1,
            repeatDelay: 1,
        });
        gsap.to(path, {
            keyframes: new Array(2)
                .fill([
                {
                    ease: 'none',
                    morphSVG: 'M8 13.5C6.58826 12.8427 4.4403 12.8335 3.13378 12.9043C2.53127 12.937 2 12.4652 2 11.8618V2.89658C2 2.38638 2.38273 1.96024 2.89198 1.92912C4.3685 1.8389 7.36892 1.7724 9.5 2.5C11.5305 3.19326 14.3503 3.16561 15.8891 3.08341C16.4836 3.05166 17 3.52002 17 4.11535V9',
                },
                {
                    ease: 'none',
                    morphSVG: 'M8 13.5C6.44122 14.2257 3.98485 13.8981 2.75468 13.6638C2.30722 13.5785 2 13.182 2 12.7265V3.74242C2 3.10402 2.59047 2.62077 3.22231 2.71204C4.78275 2.93745 7.51753 3.17686 9.5 2.5C11.6812 1.75528 14.7732 2.11978 16.2097 2.3544C16.6735 2.43016 17 2.83495 17 3.30488V9',
                },
            ])
                .flat(),
            duration: 1,
            repeat: -1,
            repeatDelay: 1,
        });
    }, []);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Money, null)));
};
//# sourceMappingURL=Money.js.map